<script>
import { Input } from 'ant-design-vue'
export default {
  props: ['value', 'id', 'url'],
  data() {
    return {
      lnglat: '',
    }
  },
  mounted() {
     const appCode = localStorage.getItem('appCode').toLocaleLowerCase()
      let bounds = [
      121.57601386424209, 28.850139780769453, 122.28311576241958, 29.652999034836032
      ]
    let center = [121.6216, 29.859515]
    if(appCode == 'dswl'){
      bounds = [
        121.920809542514,
        30.1354885899425,
        122.44207977768254,
        30.475824005651425
      ]
      center = [122.163172,30.310291]
    }
    // eslint-disable-next-line no-undef
    this.map = new AMap.Map(this.$refs.map, {
      resizeEnable: true,
      zoom: 11,
      center: center,
      viewMode: '3D',
    })
  
    if (this.url) {
      const layer = new AMap.ImageLayer({
        url: this.url,
        bounds: bounds 

        //     url: '/maptile.png',
        // bounds: new AMap.Bounds([121.56, 29.7], [122.13, 28.99]),
        // zooms: [15, 20],
      })
      this.map.add(layer)
    }
    let that = this
    // eslint-disable-next-line no-undef
    this.clickListener = this.map.on('click', function (e) {
      that.addMarker(e.lnglat)
    })
    // eslint-disable-next-line no-undef
    let autoCompleteComponent = new AMap.Autocomplete({
      input: 'tipinput',
      // outPutDirAuto: true
    })
    // eslint-disable-next-line no-undef
    AMap.event.addListener(autoCompleteComponent, 'select', (data) => {
      that.addMarker(data.poi.location)
    })
    if (this.id) {
      let lnlaObj = this.value.find((item) => item.id == this.id)
      if (lnlaObj) {
        this.map.setCenter([lnlaObj.lng, lnlaObj.lat])
      }
    }

    this.addTitle()
  },
  methods: {
    addTitle(newValue) {
      let marksValue = newValue ? newValue : this.value
      const markerList = marksValue.map(
        (item) =>
          // eslint-disable-next-line no-undef
          new AMap.Marker({
            position: [item.lng, item.lat],
            icon: item.icon || 'https://webapi.amap.com/theme/v1.3/markers/n/mark_bs.png',
          })
      )
      this.map.add(markerList)
    },
    addMarker(lnglat) {
      this.lnglat = {
        ...lnglat,
        id: this.id || Date.now(),
      }
      this.map.clearMap()
      if (this.id) {
        let index = this.value.findIndex((e) => e.id == this.id)
        let newValue = [...this.value]
        newValue.splice(index, 1)
        this.$nextTick(() => {
          this.addTitle(newValue)
        })
      } else {
        this.addTitle()
      }
      this.map.setCenter([lnglat.lng, lnglat.lat])
      let icon = new AMap.Icon({
        image: '//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-red.png',
        imageSize: new AMap.Size(20, 40),
      })
      this.map.add(
        // eslint-disable-next-line no-undef
        new AMap.Marker({
          position: [lnglat.lng, lnglat.lat],
          icon,
        })
      )
    },
    getData() {
      return this.lnglat
    },
  },
  render() {
    return (
      <div class="mapview-main">
        <div ref="map" style={{ display: 'flex', height: '300px' }} />
      </div>
    )
  },
}
</script>
<style lang="less" scoped>
.mapview-main {
  display: flex;
  flex-direction: column;
  & > div {
    margin-top: 20px;
  }
}
</style>
